import { toNumber } from '@freelancer/utils';
import type { SecurityPhoneRequestGetAjaxResult } from './security-phone-requests.backend-model';
import type { SecurityPhoneRequest } from './security-phone-requests.model';
import { transformSecurePhone } from '../users-self/users-self.transformers';

export function transformSecurityPhoneRequest(
  request: SecurityPhoneRequestGetAjaxResult,
  authUid: string,
): SecurityPhoneRequest {
  if (!request?.change_request) {
    throw new Error('Missing security phone change request.');
  }

  return {
    id: toNumber(authUid),
    ...transformSecurePhone(request.change_request),
  };
}
